import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'nepali-rupee',
  size: 24,
  node: [
    ['path', { d: 'm14 20-8-8h4c5.333 0 5.333-8 0-8', key: 'cvo5tb' }],
    ['path', { d: 'M14 8c4.078 0 5.038 4.678 2.88 6.88', key: '1t5u1p' }],
    ['path', { d: 'M6 4h12', key: '1x2ag7' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name NepaliRupee
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTQgMjAtOC04aDRjNS4zMzMgMCA1LjMzMy04IDAtOCIgLz4KICA8cGF0aCBkPSJNMTQgOGM0LjA3OCAwIDUuMDM4IDQuNjc4IDIuODggNi44OCIgLz4KICA8cGF0aCBkPSJNNiA0aDEyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/nepali-rupee
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NepaliRupee = createLucideIcon(__iconData);

export default NepaliRupee;
